import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useCallback, useState } from '@redneckz/uni-jsx/lib/hooks';
import { style } from '../../utils/style.js';
import { CloseButton } from '../DialogManager/CloseButton.js';
import { SearchInput } from '../SearchDialog/SearchInput.js';
import { useSearchDialog } from '../SearchDialog/useSearchDialog.js';
const MIN_QUERY_LEN = 3;
export const SearchBar = JSX(({ className, search, ...rest }) => {
    const [value, setValue] = useState('');
    const resetQueryOnDialogClose = useCallback(() => setValue(''), []);
    const searchDialog = useSearchDialog(rest);
    const handleInitialInputChange = useCallback((_) => {
        setValue(_);
        if (isQueryLongEnough(_)) {
            searchDialog.open({ initialQuery: _ }, { onClose: resetQueryOnDialogClose });
        }
    }, [resetQueryOnDialogClose, searchDialog]);
    return (_jsxs("div", { className: style('relative', className), role: "search", children: [_jsx(SearchInput, { value: value, placeholder: search?.placeholder, onChange: handleInitialInputChange }), _jsx(CloseButton, { className: "absolute top-0 right-0 sm:hidden", onClose: resetQueryOnDialogClose })] }));
});
const isQueryLongEnough = (_) => _ && _.length >= MIN_QUERY_LEN;
//# sourceMappingURL=SearchBar.js.map